<template>
    <div class="IperMatrizPeligrosOpcionesControlCambios">
        <div class="modal fade" :id="'controlCambios' + id" tabindex="-1" :aria-labelledby="'controlCambiosLabel' + id"
            aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content bg-light">
                    <div class="modal-header">
                        <h5 class="modal-title dato" :id="'controlCambiosLabel' + id">
                            Control de Cambios
                        </h5>
                        <button class="close" data-dismiss="modal" type="button" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="controlCambios.length > 0" class="scroll-table">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th scope="col" class="thead-table-orange">Tipo de Cambio</th>
                                        <th scope="col" class="thead-table-orange">Fecha</th>
                                        <th scope="col" class="thead-table-orange">Observación</th>
                                        <th scope="col" class="thead-table-orange">Usuario</th>
                                        <!--<th scope="col" class="thead-table-orange">Opciones</th>-->
                                    </tr>
                                </thead>
                                <tbody v-for="(item) of controlCambios" :key="item.id">
                                    <tr class="text-center">
                                        <td>{{ item.tipoCambio }}</td>
                                        <td>{{ item.fechaCambio }}</td>
                                        <td v-if="item.observacionCambio != ''">
                                            {{ item.observacionCambio }}
                                        </td>
                                        <td v-if="item.observacionCambio == ''">Sin Observación</td>
                                        <td v-if="(typeof item.correoUsuario === 'undefined')">Versión Anterior</td>
                                        <td v-else-if="item.correoUsuario != ''">{{ item.correoUsuario }}</td>
                                        <!--<td>
                                            <i class="fas fa-edit mr-3" type="button" data-toggle="modal"
                                                :data-target="'#editarControlCambios' + item.id"
                                                @click="esEditar = true; idControlCambio = item.id"></i>
                                            <i class="fas fa-trash-alt" type="button"
                                                @click="eliminarControlCambio(item.id)"></i>
                                        </td>-->
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-else class="alert alert-warning text-center" role="alert">
                            No hay registros de Control de Cambios para este
                            <b>Centro de Trabajo</b>.
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <EditarControlCambios v-if="esEditar" :idEmpresa="id" :idControlCambio="idControlCambio"
            @controlCambioEditado="controlCambioEditado" />
    </div>
</template>

<script>
import { db } from '@/firebase';
import moment from 'moment';
import Swal from 'sweetalert2';
import EditarControlCambios from './EditarControlCambios.vue';
export default {
    name: "IperMatrizPeligrosOpcionesControlCambios",

    components: {
        EditarControlCambios
    },

    props: {
        id: String
    },

    data() {
        return {
            controlCambios: [],
            idControlCambio: "",
            esEditar: false,
        };
    },

    async created() {
        this.$isLoading(true);
        /* await this.obtenerControlCambios(); */
        await this.obtenerCambios()
        this.$isLoading(false);
    },

    methods: {
        async obtenerCambios() {
            let registros = []
            const q = "cliente_empresa/" + this.id + "/controlcambios"
            await db.collection(q).orderBy("registro.creacion", "desc").get().then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    registros.unshift({
                        id: doc.id,
                        tipoCambio: doc.data().controlCambios.tipoCambio,
                        fechaCambio: moment(doc.data().controlCambios.fechaCambio.toDate()).format("DD/MM/YYYY"),
                        correoUsuario: doc.data().controlCambios.correoUsuario,
                        observacionCambio: doc.data().controlCambios.observacionCambio
                    })
                })
            })
            this.controlCambios = registros
        },

        async obtenerControlCambios() {
            let registros = [];
            let q = "cliente_empresa/" + this.id + "/controlcambios";
            await db.collection(q).orderBy("registro.creacion", "desc").get().then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    registros.unshift(doc.data());
                });
            });
            let controlCambios = await Promise.all(registros.map(async (item) => {
                return await this.obtenerUsuario(item);
            }));
            if (controlCambios.length > 0) {
                this.controlCambios = controlCambios[0];
            }
        },

        async obtenerUsuario(item) {
            let cambiosUsuario = [];
            let fechaControl = item.controlCambios.fechaCambio.toDate();
            fechaControl = moment(fechaControl).format("DD/MM/YYYY");
            if (!item.controlCambios.correoUsuario) {
                cambiosUsuario.unshift({
                    id: item.controlCambios.idControlCambio,
                    tipoCambio: item.controlCambios.tipoCambio,
                    fechaCambio: fechaControl,
                    observacionCambio: item.controlCambios.observacionCambio,
                    usuario: "VERSIÓN ANTERIOR",
                });
                return cambiosUsuario;
            }
            else {
                let cambiosUsuario = [];
                db.collection("usuarios").where("u_correo", "==", item.controlCambios.correoUsuario).get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        cambiosUsuario.unshift({
                            id: item.controlCambios.idControlCambio,
                            tipoCambio: item.controlCambios.tipoCambio,
                            fechaCambio: fechaControl,
                            observacionCambio: item.controlCambios.observacionCambio,
                            usuario: doc.data().u_nombre_usuario + " " + doc.data().u_apellido,
                        });
                    });
                });
                return cambiosUsuario;
            }
        },

        async controlCambioEditado(cambio) {
            if (cambio) {
                await this.obtenerControlCambios();
            }
            setTimeout(() => {
                this.esEditar = false;
            }, 500)
        },

        async eliminarControlCambio(id) {
            Swal.fire({
                title: "¿Seguro que desea eliminar este control de cambio?",
                text: "Una vez eliminado, se borrará permanentemente",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sí, Eliminar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.value) {
                    let q = "cliente_empresa/" + this.id + "/controlcambios";
                    db.collection(q).doc(id).delete().then(() => {
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "Datos eliminados satisfactoriamente.",
                            showConfirmButton: false,
                            timer: 1500,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        });
                        $("#controlCambios" + this.id).modal("hide");
                    });
                }
            });
        }
    },
}
</script>

<style scoped>
.thead-table-orange {
    background-color: #ee8813 !important;
    color: #ffffff !important;
    font-size: 14px;
    width: 220px !important;
    border-radius: 18px !important;
    text-align: center !important;
    background-image: linear-gradient(#e8640c, #f39200, #ff9900) !important;
}

.scroll-table {
    overflow-y: auto;
    overflow-x: auto;
    max-height: 500px;
    width: 100%;
    padding-right: 0.5em;
}
</style>